import FeaturedSoftwareCoursesSubtitle from './FeaturedSoftwareCoursesSubtitle';
//@ts-expect-error Could not find declaration file for module
import useIsEnrolledInUserGuide from '../../../hooks/useIsEnrolledInUserGuide';
import SkeletonFeaturedSoftwareCoursesHeader from './SkeletonFeaturedSoftwareCoursesHeader';
import { useIsPaidAccount } from '../../../hooks/productsHooks';
import SectionHeading, { PageSectionHeading } from '../../SectionHeading';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { HasGate } from '../../../features/accounts';
import { jsx as _jsx } from "react/jsx-runtime";
const FeaturedSoftwareCoursesHeader = ({
  isLoadingData,
  selectedTab
}) => {
  const [isEnrolled, isEnrolledRequesting] = useIsEnrolledInUserGuide();
  const [isPaidAccount, isPaidAccountRequesting] = useIsPaidAccount();
  const isLoading = isLoadingData || isEnrolledRequesting || isPaidAccountRequesting;
  return /*#__PURE__*/_jsx("div", {
    children: /*#__PURE__*/_jsx(HasGate, {
      fallback: /*#__PURE__*/_jsx(SectionHeading, {
        subText: isLoading ? /*#__PURE__*/_jsx(SkeletonFeaturedSoftwareCoursesHeader, {}) : /*#__PURE__*/_jsx(FeaturedSoftwareCoursesSubtitle, {
          isEnrolledOrPaid: isEnrolled || isPaidAccount,
          selectedTab: selectedTab
        }),
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "learningCenter.featuredSoftwareCourses.genericTitle"
        })
      }),
      gate: "Academy:UnifiedAcademy:Navigation",
      children: /*#__PURE__*/_jsx(PageSectionHeading, {
        subtitle: isLoading ? /*#__PURE__*/_jsx(SkeletonFeaturedSoftwareCoursesHeader, {}) : /*#__PURE__*/_jsx(FeaturedSoftwareCoursesSubtitle, {
          isEnrolledOrPaid: isEnrolled || isPaidAccount,
          selectedTab: selectedTab
        }),
        title: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "learningCenter.featuredSoftwareCourses.genericTitle"
        })
      })
    })
  });
};
export default FeaturedSoftwareCoursesHeader;